<template>
  <article class="section section--full-width">
    <header class="section__header">
      <h1 class="section__title">Pacientes</h1>
    </header>

    <section class="section__wrapper">
      <ul class="section__nav tabbed-nav">
        <li
          v-for="(list, index) in lists"
          :key="`patientListLink_${index}`"
          :class="(listType === list.type) ? 'active' : ''"
          class="tabbed-nav__item"
        >
          <router-link
            :to="list.routerLink"
            class="tabbed-nav__link"
          >
            {{ list.name }}
          </router-link>
        </li>
      </ul>

      <div class="section__body">
        <section class="section__wrapper report__wrapper">
          <div
            v-if="filters.length > 0"
            class="report__filters !flex-no-wrap"
          >
            <div
              v-for="(filter, index) in filters.filter(f => f.name !== 'doctorOffice')"
              :key="`report_filter_${index}`"
              class="report__filters-item !w-full"
            >
              <label class="report__filters-label">
                {{ filter.label }}
              </label>

              <template v-if="filter.type === 'text'">
                <div class="report__filters-field !w-full">
                  <input
                    v-model="filter.value"
                    :placeholder="filter.placeholder"
                    type="text"
                    class="report__filters-text !w-full"
                  >

                  <i
                    v-show="filter.value"
                    class="icon icon-cross report__filters-reset"
                    @click="filter.value = null"
                  />
                </div>
              </template>
            </div>

            <div
              v-if="listType === 'specialPatient'"
              class="report__filters-item patients__links !w-full !items-end"
            >
              <router-link
                v-if="false"
                class="btn btn-sm import patients__links-item !w-full"
                :to="`/${prefix}/patients/import`"
              >
                <dr-icon class="upload import-data" name="upload" color="white" />
                Importar dados
              </router-link>

              <button
                class="btn btn-sm btn-lg btn-primary patients__links-item !mb-0 !w-full"
                @click="ui.modalActive = true"
              >
                <i class="icon icon-plus" /> Adicionar paciente
              </button>

              <transition name="fade-in">
                <special-patient
                  v-if="ui.modalActive"
                  class="modal"
                  :patient-id.sync="ui.patientEdit"
                  @cancel="ui.modalActive = null; ui.patientEdit = null"
                  @success="getList()"
                />
              </transition>
            </div>
          </div>

          <div class="report__body">
            <dr-loader
              v-if="ui.isLoading"
              size="lg"
              class="report__loader"
            />

            <p
              v-if="!ui.isLoading && Array.isArray(data.rows) && data.rows.length === 0"
              class="report__no-results"
            >
              Nenhum resultado encontrado.
            </p>

            <template
              v-if="!ui.isLoading && Array.isArray(data.rows) && data.rows.length > 0"
              tag="div"
              class="report__table"
            >
              <header
                v-if="fn_IS_MOBILE()"
                class="report__table-header mobile"
                :class="$store.getters.getNewCertifierCredentialRequired ? 'withCredentials' : '' ">
                <div
                  :class="data.keys[0].class"
                  class="report__table-col"
                >
                  {{ data.keys[0].title }}
                  <i
                    :class="sort[sorted.value].icon"
                    class="icon clickable"
                    @click="sorted = sortable.next()"
                  />
                </div>
                <div class="report__table-col">
                  <select v-model="ui.selectedCol">
                    <template v-for="(key, index) in data.keys">
                      <option
                        v-if="index > 0 && key.name !== 'actions'"
                        :value="key.name" :key="`option${key.title}`">{{ key.title }}</option>
                    </template>
                  </select>
                </div>
              </header>
              <div v-else class="report__table-header">
                <div
                  v-for="(key, index) in data.keys"
                  :key="`report_header_item_${index}`"
                  :class="key.class"
                  class="report__table-col"
                >
                  <div v-if="key.name === 'name'">
                    {{ key.title }}

                    <i
                      :class="sort[sorted.value].icon"
                      class="icon clickable"
                      @click="sorted = sortable.next()"
                    />
                  </div>

                  <span v-else>
                    {{ key.title }}
                  </span>
                </div>
              </div>

              <div
                v-for="(row, index) in getRows"
                :key="`report_table_row_${index}`"
                class="report__table-row"
              >
                <div
                  v-for="(cell, i) in row"
                  v-show="!cell.hide"
                  :key="`report_table_row_${index}_cell_${i}`"
                  :class="cell.class"
                  class="report__table-cell"
                >
                  <span
                    v-if="cell.name === 'name'"
                    class="report__table-cell--highlight"
                  >
                    {{ cell.value }}
                    <div v-if="fn_IS_MOBILE()" class="report__table-cell--actions flex-wrap">
                    <div
                        class="patients__actions"
                      >
                        <router-link
                          tag="span"
                          :to="`/${prefix}/patients/details/${listType}/${data.rows[index][3].value}`"
                        >
                          <dr-icon
                            :color="'#56bdd2'"
                            class="patients__actions-icon !w-4 !mr-2 my-2"
                            name="lupa"
                          />
                        </router-link>

                        <span
                          v-if="listType === 'specialPatient'"
                          @click="ui.patientEdit = data.rows[index][3].value; ui.modalActive = true;"
                        >
                          <dr-icon
                            :color="'#56bdd2'"
                            class="patients__actions-icon  !w-4 my-2"
                            name="edit"
                          />
                        </span>
                      </div>
                    </div>
                  </span>

                  <span v-if="cell.name === 'email'">
                    {{ cell.value || '(não informado)' | TO_ALL_LOWER }}
                  </span>

                  <span v-if="cell.name === 'phone'">
                    {{ cell.value || '(não informado)' | TO_TEL }}
                  </span>

                  <div
                    v-if="cell.name === 'actions'"
                    class="patients__actions"
                  >
                    <router-link
                      tag="span"
                      :to="`/${prefix}/patients/details/${listType}/${cell.value}`"
                    >
                      <dr-icon
                        :color="'#56bdd2'"
                        class="patients__actions-icon"
                        name="lupa"
                      />
                    </router-link>

                    <span
                      v-if="listType === 'specialPatient'"
                      @click="ui.patientEdit = cell.value; ui.modalActive = true;"
                    >
                      <dr-icon
                        :color="'#56bdd2'"
                        class="patients__actions-icon"
                        name="edit"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </section>
      </div>
    </section>

    <footer
      v-if="ui.hasLoaded && pagination.totalPages > 1"
      class="section__footer"
    >
      <nav class="pagination">
        <transition name="fade" mode="out-in">
          <table-pagination
            :total-pages.sync="pagination.totalPages"
            :current-page.sync="pagination.currentPage"
            class="text-right"
            @updated="getList($event)"
          />
        </transition>
      </nav>
    </footer>
  </article>
</template>

<script>
import specialPatient from '@/components/modals/specialPatient'
import tablePagination from '@/components/tables/tablePagination'
import { mapGetters } from 'vuex'

export default {
  name: 'DrPatientsList',

  components: {
    specialPatient,
    tablePagination
  },

  data () {
    return {
      lists: [
        {
          name: 'Particulares',
          type: 'specialPatient',
          apiRoute: '/special_patient',
          routerLink: {
            name: `${this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary'}PatientsList`,
            params: { type: 'specialPatient' }
          }
        },
        {
          name: 'Dr. Conecta',
          type: 'patient',
          apiRoute: '/patient',
          routerLink: {
            name: `${this.fn_IS_DOCTOR() ? 'Doctor' : 'Secretary'}PatientsList`,
            params: { type: 'patient' }
          }
        }
      ],
      filters: [
        {
          name: 'name',
          label: 'Filtrar por nome',
          placeholder: 'Digite o nome',
          type: 'text',
          value: null
        },
        {
          name: 'doctorOffice',
          value: null
        }
      ],
      sort: [
        {
          value: '',
          icon: 'icon-resize-vert'
        },
        {
          value: 'asc',
          icon: 'icon-downward'
        },
        {
          value: 'desc',
          icon: 'icon-upward'
        }
      ],
      sorted: null,
      sortable: null,
      data: {
        keys: [
          {
            title: 'Nome',
            name: 'name',
            class: 'report__table-col--30'
          },
          {
            title: 'E-mail',
            name: 'email',
            class: 'report__table-col--30'
          },
          {
            title: 'Telefone',
            name: 'phone',
            class: 'report__table-col--30'
          },
          {
            title: 'Ações',
            name: 'actions',
            class: 'report__table-col--10'
          }
        ],
        rows: null
      },
      pagination: {
        totalRows: null,
        totalPages: null,
        currentPage: null
      },
      itemsPerPage: 15,
      ui: {
        isLoading: false,
        hasLoaded: false,
        modalActive: false,
        patientEdit: null,
        selectedCol: 'email'
      }
    }
  },

  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices',
      office: 'getCurrentOffice'
    }),

    listType () {
      return this.$route.params.type || 'specialPatient'
    },

    activeList () {
      return this.lists.find(list => list.type === this.listType)
    },

    activeEndPoint () {
      return `${
        this.prefix
      }${
        this.activeList.apiRoute
      }?itensPerPage=${
        this.itemsPerPage
      }${
        this.queryString
      }${
        this.sortString
      }`
    },

    prefix () {
      return this.fn_IS_DOCTOR()
        ? 'doctor'
        : `secretary/doctor/${this.$route.params.doctorId}`
    },

    getRows () {
      let arr = []
      for (let row of this.data.rows) {
        let newRow = {}
        for (let col in row) {
          if (this.getSelectedCol && this.fn_IS_MOBILE()) {
            if (row[col].name === this.getSelectedCol || row[col].name === 'name') {
              newRow[col] = row[col]
              if (!newRow[col].value) {
                newRow[col].value = '(não informado)'
              }
            }
          } else {
            newRow[col] = row[col]
            if (!newRow[col].value) {
              newRow[col].value = '(não informado)'
            }
          }
        }
        arr.push(newRow)
      }

      return arr
    },

    getSelectedCol () {
      return this.ui.selectedCol
    },

    queryString () {
      return this.filters.reduce((prev, next, i) => {
        const isTelemedicine = this.doctorOffices.find((office) => office.type === 'TELEMEDICINE') || null

        const queryString = next.name === 'doctorOffice'
          ? isTelemedicine ? `&filterIn[do.id][]=${isTelemedicine.id}&filterIn[do.id][]=` : '&filterIn[do.id][]='
          : `&filterAndLike[${this.listType === 'specialPatient' ? 'sp' : 'u'}.name]=`

        return next.value
          ? `${prev}${queryString}${next.value}`
          : prev
      }, '')
    },

    sortString () {
      return this.sorted && 'value' in this.sorted && this.sorted.value
        ? `&order[${
          this.listType === 'specialPatient' ? 'sp' : 'u'
        }.name]=${
          this.sort[this.sorted.value].value
        }`
        : ''
    }
  },

  watch: {
    'office.id': {
      deep: true,
      immediate: true,
      handler (id) {
        this.filters.find(f => f.name === 'doctorOffice').value = this.office.id
      }
    },

    activeEndPoint: {
      deep: false,
      immediate: false,
      handler (next, prev) {
        if (prev !== next) {
          this.getList()
        }
      }
    },

    activeList: {
      deep: false,
      immediate: false,
      handler (next, prev) {
        if (prev !== next) {
          this.sortable = this.sortColumn()
          this.sorted = this.sortable.next()
          this.getList()
        }
      }
    }
  },

  created () {
    this.sortable = this.sortColumn()
    this.sorted = this.sortable.next()
  },

  mounted () {
    this.getList()
  },

  destroyed () {
    this.sortable = null
    this.sorted = null
  },

  methods: {
    getList (page = 1) {
      const url = `${this.activeEndPoint}&page=${page}`

      this.ui.isLoading = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .get(url, this.$store.getters.getAuthHeader)
        .then((res) => {
          this.pagination = res.data.pagination
          this.data.rows = res.data.data
            .map(this.handleData)
        })
        .finally(() => {
          this.ui.isLoading = false
          this.ui.hasLoaded = true
          this.fn_HIDE_PROGRESS()
        })
    },

    handleData (row) {
      const id = { name: 'actions', value: row['id'], class: 'report__table-cell--10' }
      const name = { name: 'name', value: row['name'], class: 'report__table-cell--30' }
      const email = { name: 'email', value: row['email'], class: 'report__table-cell--30' }
      const phone = { name: 'phone', value: row['contact_phone'], class: 'report__table-cell--30' }

      return [name, email, phone, id]
    },

    * sortColumn () {
      while (true) {
        yield 1
        yield 2
        yield 0
      }
    }
  }
}
</script>
